import React, { useEffect, useState } from 'react'
import {
    Button,
    Modal,
    Pagination,
    Skeleton,
    Stack,
    TableCell,
    TableRow,
    Typography,
    Box
} from '@mui/material';
import { Link, useNavigate, useParams } from 'react-router'
import { formatDate } from '../../lib/formateDate';
import Loader from '../../Components/Loader';
import { usePageStore } from '../../store/usePageStore';
import TruncatedText from '../../Components/TruncatedText';

const DisplayConcrete = () => {
    const navigate = useNavigate()
    let { getPageData, concrete, deletepage } = usePageStore()
    const [pageSize, setPageSize] = useState(3);
    const [totalPages, setTotalPages] = useState(1);
    const [pageNumber, setPageNumber] = useState(1);
    const [pageName, setPageName] = useState('concrete');
    const [search, setSearch] = useState('');
    const [field, setField] = useState('title');
    const [loading, setLoading] = useState('');
    const [itemId, setItemId] = useState('');
    const [open, setOpen] = useState('');

    const getPagedataFunction = async () => {
        setLoading(true)
        let res = await getPageData(pageNumber, pageSize, search, field, pageName)
        if (res) {
            setTotalPages(res?.totalPages);
        }
        setLoading(false)
    }

    const handleChangePagination = (event, value) => {
        setPageNumber(value);
    };

    const handleSearchChange = (e) => {
        setPageNumber(1)
        setLoading(true);
        setSearch(e)
    };

    const handleDelete = (id) => {
        setItemId(id)
        setOpen(true)
    }

    const handleCancelDelete = () => {
        setOpen(false);
    };

    const handleEdit = (id) => {
        navigate(`/nonprofitable/event/add?id=${encodeURIComponent(id)}`);
    };

    const handleConfirmDelete = async () => {
        try {
            setOpen(false)
            setLoading(true)
            const res = await deletepage(itemId, 'concrete')
            setLoading(false)
        } catch (error) {
            setLoading(false)
            console.log(error)
        }
    }

    useEffect(() => {
        getPagedataFunction()
    }, [pageNumber, search, field])
    return (
        <div>
            <div className="bg-white p-4 rounded-md shadow-sm border border-neutral-200 mb-6">
                <div className="flex items-center justify-between">
                    <div className="flex items-center space-x-4">
                        <div className="relative">
                            <input type="text"
                                placeholder="Search concrete..."
                                className="pl-8 pr-4 py-2 border border-neutral-300 rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-neutral-400"
                                value={search}
                                onChange={(e) => handleSearchChange(e.target.value)}
                            />
                            <i className="fa-solid fa-search absolute left-3 top-2.5 text-neutral-400 text-sm"></i>
                        </div>
                        {/* <select class="px-3 py-2 border border-neutral-300 rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-neutral-400">
                            <option>All Projects</option>
                            <option>Residential</option>
                            <option>Commercial</option>
                            <option>Industrial</option>
                        </select>
                        <select class="px-3 py-2 border border-neutral-300 rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-neutral-400">
                            <option>All Status</option>
                            <option>Completed</option>
                            <option>In Progress</option>
                            <option>Upcoming</option>
                        </select> */}
                    </div>
                    {/* <div class="flex items-center space-x-2">
                        <button class="px-3 py-2 border border-neutral-300 rounded-md text-sm flex items-center">
                            <i class="fa-solid fa-filter mr-2"></i>
                            More Filters
                        </button>
                        <button class="px-3 py-2 border border-neutral-300 rounded-md text-sm flex items-center">
                            <i class="fa-solid fa-download mr-2"></i>
                            Export
                        </button>
                    </div> */}
                </div>
            </div>
            <Loader loading={loading}>
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-6">
                    {
                        (concrete || []).map((ele, i) => (
                            <div id="project-1" key={i} className="bg-white rounded-md shadow-sm border border-neutral-200 overflow-hidden">
                                <div className="relative h-48 bg-neutral-700 flex items-center justify-center rounded-lg overflow-hidden">
                                    <img
                                        src={ele?.image}
                                        alt="Project"
                                        className="w-full h-full object-cover"
                                    />
                                    <div className="absolute top-2 right-2 flex space-x-2">
                                        <Link to={`/concrete/form?id=${ele?._id}`} class="p-1.5 bg-white bg-opacity-80 rounded-md text-neutral-700 hover:bg-opacity-100">
                                            <i className="fa-solid fa-edit"></i>
                                        </Link>
                                        <button className="p-1.5 bg-white bg-opacity-80 rounded-md text-neutral-700 hover:bg-opacity-100"
                                            onClick={() => handleDelete(ele?._id)}>
                                            <i className="fa-solid fa-trash-alt"></i>
                                        </button>
                                    </div>
                                </div>

                                <div className="p-4">
                                    <div className="flex justify-between items-center mb-2">
                                        <h3>{ele?.title}</h3>
                                        <span className="px-2 py-1 bg-neutral-100 text-neutral-800 rounded-full text-xs">Completed</span>
                                    </div>
                                    <div className="text-sm text-neutral-500 mb-2">
                                        {ele?.marketType}
                                    </div>

                                    <p className="text-sm text-neutral-600 mb-4">
                                        <TruncatedText text={ele?.description} limit={150} />
                                    </p>
                                    <div className="flex items-center justify-end text-sm text-neutral-500">

                                        <div>
                                            <i className="fa-solid fa-calendar mr-1"></i>
                                            {formatDate(ele?.createdAt)}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))
                    }

                </div>
            </Loader>

            <div className="flex justify-end items-center mb-6">
                <div className="flex justify-between items-center mb-6">
                    <Stack spacing={2} className="flex items-end mt-4">
                        <Pagination
                            count={totalPages}
                            onChange={handleChangePagination}
                            variant="outlined"
                            shape="rounded"
                            sx={{
                                "& .MuiPaginationItem-root": {
                                    color: "white",
                                    borderColor: "#000",
                                    backgroundColor: "#000",
                                },
                                "& .Mui-selected": {
                                    backgroundColor: "#333 !important",
                                    color: "white",
                                },
                                "& .MuiPaginationItem-root:hover": {
                                    backgroundColor: "#444",
                                    color: "white",
                                },
                            }}
                        />
                    </Stack>
                </div>
            </div>

            <Modal
                open={open}
                onClose={handleCancelDelete}
                aria-labelledby="confirm-delete-modal"
                aria-describedby="modal-to-confirm-deletion"
            >
                <Box
                    sx={{
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                        backgroundColor: 'white',
                        padding: '20px',
                        borderRadius: '5px',
                        boxShadow: 24,
                        width: { xs: "80%", md: "500px" },
                        textAlign: 'center',
                    }}
                >
                    <Typography variant="h6" gutterBottom>
                        Are you sure you want to delete this Concrete?
                    </Typography>
                    <Button variant="outlined" color="#274156" onClick={handleConfirmDelete}>
                        Yes
                    </Button>
                    <Button variant="outlined" color="#274156" onClick={handleCancelDelete} sx={{ marginLeft: '10px' }}>
                        No
                    </Button>
                </Box>
            </Modal>
        </div >
    )
}

export default DisplayConcrete
